import React, { useState } from "react";
import { Tooltip, TextField } from "@mui/material";
import { set } from "lodash";
import { errorJsonHasErrors } from "./Input_Fns";

export const InputPercentage = ({
  percent,
  label,
  name,
  minPct = 0,
  maxPct = 100,
  step = 1,
  required = false,
  onChange,
  tooltip = "",
  onError = null,
  width = 80,
  errors_ = null,
  ...others
}) => {
  const [errors, setErrors] = useState({})

  const onBlur = (e) => {
    let ne = structuredClone(errors)
    let err = ""

    if (e.target.name === name) {
      if ((required || (!required && percent !== 0)) && percent < minPct || percent > maxPct) {
        //err = "Please enter between " + minPct + " and " + maxPct
        err = "" + minPct + " to " + maxPct
      }
      if (errors_ !== null && err === "" && errors_[name] !== "") {
        err = errors_[name]
      }

      ne = set(ne, e.target.name, err)
      setErrors(ne)
      if (onError !== null) {
        onError(errorJsonHasErrors(ne) ? "Errors" : "")
      }
      //console.log(ne)
    }
  }

  return (
    <Tooltip title={tooltip} arrow>
      <TextField
        label={label}
        name={name}
        type="number"

        slotProps={{
          htmlInput: {
            min: minPct,
            max: maxPct,
            step: step,
          }
        }}
        required={required}
        onWheel={(e) => e.target instanceof HTMLElement && e.target.blur()}
        sx={{ width: width }}
        size="small"
        value={percent}
        onChange={onChange}
        error={!!errors[name]}
        helperText={errors[name]}
        onBlur={onBlur}
        {...others}
      />
    </Tooltip>
  );
};

export const InputPercentageSpouse = ({
  percent,
  name = "SpousePercentage",
  required = false,
  onChange,
  ...others
}) => {
  return (
    <InputPercentage
      percent={percent}
      label="Spouse %"
      name={name}
      required={required}
      onChange={onChange}
      tooltip="Spouse's percentage of the value"
      {...others}
    />
  );
};

export const InputPercentageInflation = ({
  percent,
  name = "Rate",
  required = false,
  onChange,
  minPct = 0,
  maxPct = 10,
  ...others
}) => {
  return (
    <InputPercentage
      percent={percent}
      label="Inf %"
      name={name}
      minPct={minPct}
      maxPct={maxPct}
      step={0.01}
      required={required}
      onChange={onChange}
      tooltip="Special inflation rate for this value on this account as long as the value is applied or calculated based on this input. This will supercede any inflation rate for the client or the scenario"
      {...others}
    />
  );
};
